import { render } from "./RicorrenzaBadge.vue?vue&type=template&id=4fb3e518"
import script from "./RicorrenzaBadge.vue?vue&type=script&lang=js"
export * from "./RicorrenzaBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__